import {SEARCH_MOVIES} from "../queries";
import {useQuery} from "@apollo/client";
import {Box, CircularProgress, Grid, Stack} from "@mui/material";
import MovieCard from "./MovieCard";

export default function SearchResult({search}) {
    const {loading, error, data} = useQuery(SEARCH_MOVIES, {
        variables: {query: search},
    });

    if (loading) return <Stack alignItems="center">
        <CircularProgress/>
    </Stack>;

    if (error) return <p>Error :(</p>;

    return <Box sx={{flexGrow: 1, mt: 6}}>
        <Grid container spacing={3}>
            {data.searchMovies.map((movie) => (
                <Grid key={movie.id} item xs={6} sm={6} md={4} lg={3}>
                    <MovieCard movie={movie}/>
                </Grid>
            ))}
        </Grid>
    </Box>;
}